<app-modal
  [title]="title"
  maxWidth="400px"
  [compact]="true"
  (closed)="cancel()"
>
  <ng-template>
    <p [innerHTML]="text"></p>
  </ng-template>

  <ng-container modal-buttons>
    <div class="d-flex gap-16 m-t-16 justify-content-flex-end">
      <button
        class="button button--md button--primary-ghost text-uppercase"
        (click)="close()"
      >
        {{ cancelButtonText }}
      </button>
      <button
        class="button button--md button--primary text-uppercase"
        (click)="confirm()"
      >
        {{ confirmButtonText }}
      </button>
    </div>
  </ng-container>
</app-modal>
